/* eslint-disable max-len */
/* eslint-disable no-plusplus */
export const CamelCase = (str) => str?.split(' ').map((w) => { if (w.length > 0) return w[0].toUpperCase() + w.substring(1).toLowerCase(); return ''; }).join(' ');

export const TitleCase = (str) => {
    const splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
};
export const TitleCaseUnderscore = (str) => {
    const splitStr = str.toLowerCase().split('_');
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
};
export const PriceHandler = (price) => Number(price || 0)?.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
});
